import { render } from "./container-details-info.vue?vue&type=template&id=00320d7d&scoped=true"
import script from "./container-details-info.vue?vue&type=script&lang=js"
export * from "./container-details-info.vue?vue&type=script&lang=js"

import "./container-details-info.vue?vue&type=style&index=0&id=00320d7d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00320d7d"]])

export default __exports__